import React, { useState } from "react";
import { useRouter, Link } from "../router";
import { useAuth } from "../auth-context";
import { peekPendingAction, resumePendingAction } from "../pendingAction";

export default function RegisterPage() {
  const { register } = useAuth();
  const { navigate } = useRouter();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [pending] = useState(() => peekPendingAction());

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(email, password, name);
      const handled = await resumePendingAction(navigate);
      if (!handled) navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page page-narrow">
      <div className="auth-card">
        <h1>Create your account</h1>
        {pending && (
          <div className="alert alert-warning">
            {pending.type === "voucher"
              ? "Sign up to finish redeeming your voucher code."
              : "Sign up to continue enrolling in this course."}
          </div>
        )}
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit} autoComplete="on">
          <label>
            Name
            <input name="name" autoComplete="name" required value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Password
            <input
              type="password"
              name="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button className="btn btn-primary btn-block" disabled={busy}>
            {busy ? "Creating account…" : "Sign up"}
          </button>
        </form>
        <p className="muted" style={{ marginTop: 16 }}>
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
}
